import { useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { KeyContext } from "../contexts/key-context";
import { chromaticKeys } from "../utils/chord-lookup";

const KeyDropdown = () => {
  const { keyValue, dispatch } = useContext(KeyContext);
  return (
    <Dropdown>
      <Dropdown.Toggle className="glass-btn">{keyValue}</Dropdown.Toggle>
      <Dropdown.Menu className="scrollable-menu">
        {chromaticKeys.map((value) => {
          return (
            <Dropdown.Item
              as="button"
              key={value}
              value={value}
              onClick={() => {
                dispatch({ type: "KEY", keyValue: value });
              }}
            >
              {value}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default KeyDropdown;
